import { Fragment, useEffect, useRef, useState } from "react";
import { Combobox, Transition } from "@headlessui/react";
import { ChevronDownIcon, PlusIcon } from "@heroicons/react/24/outline";
import useGetHook from "../../../customHooks/useGetHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useDebounce } from "../../../customHooks/useDebounceHook";
export default function ComboboxInput(props: any) {
  const {
    url,
    queryKey,
    props: otherProps,
    errors,
    setValue,
    name,
    getValues,
    clearErrors,
    disabled = false,
  } = props;
  const limit: number = 10;
  const [query, setQuery] = useState("");
  const comboboxButtonRef = useRef<HTMLButtonElement>(null);
  const [selected, setSelected] = useState<any>("");
  const debounceSearch = useDebounce(query);
  const [data, setData] = useState([]);
  useEffect(() => {
    setValue(name, selected?.id ?? null);
  }, [selected]);

  useEffect(() => {
    if (!selected && getValues()?.[name]) {
      setSelected(getValues()?.[name]);
    } else if (
      typeof getValues()?.[name] === "object" &&
      getValues()?.[name] !== null
    ) {
      setValue(name, selected?.id ?? null);
    } else if (!getValues()?.[name]) {
      setSelected("");
    }
  }, [getValues()?.[name]]);

  const filtereddata: any =
    query === ""
      ? data
      : data.filter((person: any) =>
          person?.name
            .toLowerCase()
            .replace(/\s+/g, "")
            .includes(query.toLowerCase().replace(/\s+/g, ""))
        );
  const { data: serverData } = useGetHook({
    queryKey: [queryKey, `${queryKey}-${limit}-${debounceSearch}`],
    url: url,
    params: {
      limit: limit,
      offset: 0,
      search: debounceSearch,
      ...otherProps,
    },
  });
  useEffect(() => {
    if (Array.isArray(serverData?.results)) {
      setData(serverData?.results ?? []);
    }
  }, [serverData]);
  return (
    <>
      <Combobox value={selected} disabled={disabled} onChange={setSelected}>
        <div className={tw`relative mt-3`}>
          <label>{props?.label}</label>

          <div
            className={tw`relative w-full cursor-default overflow-hidden  bg-white text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-teal-300 sm:text-sm mt-2`}
          >
            <Combobox.Input
              className={tw`w-full focus:outline-none bg-[#EEF5F4] p-[10px] text-left`}
              placeholder={props?.placeholder}
              onBlur={() => clearErrors(name)}
              displayValue={(person: any) => person?.name}
              onChange={(event) => setQuery(event.target.value)}
              onClick={() => {
                comboboxButtonRef?.current?.click();
              }}
            />
            <Combobox.Button
              ref={comboboxButtonRef}
              className={tw`absolute inset-y-0 right-0 flex items-center pr-2`}
            >
              {selected && (
                <PlusIcon
                  className={tw`h-5 w-5 text-gray-400 rotate-45`}
                  aria-hidden="true"
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent Combobox from opening
                    setSelected(null); // Clear selection
                    setValue(name, ""); // Reset form value
                  }}
                />
              )}
              <ChevronDownIcon
                className={tw`h-5 w-5 text-gray-400`}
                aria-hidden="true"
              />
            </Combobox.Button>
          </div>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => setQuery("")}
          >
            <Combobox.Options
              className={tw`absolute z-50 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm`}
            >
              {filtereddata?.length === 0 && query !== "" ? (
                <div
                  className={tw`relative cursor-default select-none py-2 px-4 text-gray-700`}
                >
                  Nothing found.
                </div>
              ) : (
                filtereddata.map((person: any) => (
                  <Combobox.Option
                    key={person.id}
                    className={({ active }) =>
                      tw`relative cursor-default select-none py-2 pl-10 pr-4 ${
                        active ? tw`bg-primary text-white` : tw`text-gray-900`
                      }`
                    }
                    value={person}
                  >
                    {({ selected, active }) => (
                      <>
                        <span
                          className={tw`block truncate ${
                            selected ? tw`font-medium` : tw`font-normal`
                          }`}
                        >
                          {person.name}
                        </span>
                        {selected ? (
                          <span
                            className={tw`absolute inset-y-0 left-0 flex items-center pl-3 ${
                              active ? tw`text-white` : tw`text-teal-600`
                            }`}
                          >
                            {/* <CheckIcon className="h-5 w-5" aria-hidden="true" /> */}
                          </span>
                        ) : null}
                      </>
                    )}
                  </Combobox.Option>
                ))
              )}
            </Combobox.Options>
          </Transition>
          {errors && (
            <p className={tw`text-red-500 text-xs my-1`}>{errors?.message}</p>
          )}
        </div>
      </Combobox>
    </>
  );
}
